import { Component, Output, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { ImageCroppedEvent, CropperPosition } from 'ngx-image-cropper';
import { CropperPositionImpl } from './cropper-position';

@Component({
    selector: 'dp-image-cropper',
    templateUrl: 'image-cropper.component.html',
    styleUrls: ['image-cropper.component.scss']
})
export class ImageCropperComponent implements OnInit {
    @Output() public image = new EventEmitter<any>();
    @Output() public remove = new EventEmitter<any>();
    @ViewChild('cropperElem', { static: false }) cropper: ImageCropperComponent;
    @Input() public btnName: string;
    @Input() public originalImage: any;
    @Input() public classIcon: string;
    @Input() public setCropperPosition: any;
    @Input() public controls = true;
    @Input() public autoCrop = true;

    public imageChangedEvent: any = '';
    public croppedImage: any = '';
    public cropperReady = false;
    public loading = false;
    public loadFailed = false;
    public imgLoaded = false;

    public cropperPosition: CropperPosition = new CropperPositionImpl();

    public ngOnInit() {
        if (this.originalImage) {
            this.loading = true;
        }

        this.imageChangedEvent = this.originalImage;
    }

    public fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
        this.loading = true;
    }

    public imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;

        this.image.emit({
            imageCropped: this.croppedImage,
            original: this.imageChangedEvent,
            cropperPosition: event.cropperPosition
        });
    }

    public imageLoaded() {
        this.imgLoaded = true;
        this.cropperReady = true;
        this.loadFailed = false;
    }

    public isReadyToCropp() {
        this.loading = false;

        // tslint:disable-next-line: triple-equals
        if (this.setCropperPosition && this.setCropperPosition.x1 != null) {
            this.cropperPosition = this.setCropperPosition;
        }
    }

    public loadImageFailed() {
        this.loading = false;
        this.loadFailed = true;
    }

    public onRemove(image) {
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.cropperReady = false;
        this.loading = false;
        this.loadFailed = false;
        this.imgLoaded = false;
        this.originalImage = '';

        this.remove.emit(image);
    }

     flipVertical() {
        this.cropper.flipVertical();
      }
    
      flipHorizontal() {
        this.cropper.flipHorizontal();
      }
    
      rotateLeft() {
        this.cropper.rotateLeft();
      }
    
      rotateRight() {
        this.cropper.rotateRight();
      }
}
